import {
  FormCustomFieldRendererParams,
  useFormFieldError,
  useFormFieldValue,
} from '@/components/Form';
import { TagInputProps } from '@/modules/corporate/modules/tags/types';
import { DEFAULT_TAG_VALUE } from '@/modules/corporate/modules/tags/utils';
import { TagAvailableOnEnum } from '@/types/schema';

import ContentTags from '../components/Tags';

const RENDER_TAGS_FOR_CONTENT = [TagAvailableOnEnum.Content];
const RENDER_TAGS_FOR_EVENTS = [TagAvailableOnEnum.Event];
const RENDER_TAGS_FOR_OKR = [TagAvailableOnEnum.Okr];
const RENDER_TAGS_FOR_USER = [TagAvailableOnEnum.User];
const RENDER_TAGS_FOR_TASK = [TagAvailableOnEnum.Task];

const Tags = ({
  formikData,
  availableOn,
  readonly,
}: {
  formikData: FormCustomFieldRendererParams<TagInputProps>;
  availableOn: TagAvailableOnEnum[];
  readonly?: boolean;
}) => {
  const { setFieldValue } = formikData;
  const fieldKey = 'tags';
  const tag = (useFormFieldValue(fieldKey) || DEFAULT_TAG_VALUE) as TagInputProps;
  const error = useFormFieldError(fieldKey);

  const subWorkspaceIds = useFormFieldValue('subWorkspaceIds');

  return (
    <ContentTags
      availableOn={availableOn}
      error={error}
      readonly={readonly}
      setFieldValue={setFieldValue}
      subWorkspaceIds={subWorkspaceIds}
      tag={tag}
    />
  );
};

export const renderTagsForContentForPath = (
  formikData: FormCustomFieldRendererParams<TagInputProps>,
  readonly: boolean = false,
) => {
  return <Tags availableOn={RENDER_TAGS_FOR_CONTENT} formikData={formikData} readonly={readonly} />;
};

export const renderTagsForContent = (formikData: FormCustomFieldRendererParams<TagInputProps>) => {
  return <Tags availableOn={RENDER_TAGS_FOR_CONTENT} formikData={formikData} />;
};

export const renderTagsForEvent = (formikData: FormCustomFieldRendererParams<TagInputProps>) => {
  return <Tags availableOn={RENDER_TAGS_FOR_EVENTS} formikData={formikData} />;
};

export const renderTagsForOkr = (formikData: FormCustomFieldRendererParams<TagInputProps>) => {
  return <Tags availableOn={RENDER_TAGS_FOR_OKR} formikData={formikData} />;
};

export const renderTagsForUser = (formikData: FormCustomFieldRendererParams<TagInputProps>) => {
  return <Tags availableOn={RENDER_TAGS_FOR_USER} formikData={formikData} />;
};

export const renderTagsForTask = (formikData: FormCustomFieldRendererParams<TagInputProps>) => {
  return <Tags availableOn={RENDER_TAGS_FOR_TASK} formikData={formikData} />;
};
